<template>
  <div id="shopping-submit">
    <div class="wrap">
      <div class="wrap_zh">
        <div class="shopping-title">
          <div class="shopping-title_name fl">填写订单信息</div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="wrap_zh shopping-submit">
        <div class="shopping-submit_detail fl">
          <div class="shopping-detail_title shopping-submit_top fl">
            <span></span>
            <font>收货地址</font>
          </div>
          <div class="shopping-submit-address fl">
            <div class="shopping-submit-address fl">
              <div
                class="shopping-submit-address_li fl"
                v-for="(item,index) in addressList"
                :key="index"
              >
                <div
                  class="shopping-submit-address_select fl"
                  :class="item.selected && 'on'"
                  @click="operaSelectAddress(item,index)"
                >
                  <span>
                    <font v-if="item.selected">✔</font>
                  </span>
                </div>
                <div class="shopping-submit-address_info fl">
                  <div class="shopping-submit-address_info-user">
                    <span>收货人：</span>
                    <el-input
                      placeholder="请输入内容"
                      v-model="addressObj.receiverName"
                      v-if="item.selected"
                      @blur="operaValidate"
                    ></el-input>
                    <font v-if="!item.selected">{{item.receiverName}}</font>
                    <span>收货人联系方式：</span>
                    <el-input
                      class="shopping-submit-address_info-user_phone"
                      placeholder="请输入内容"
                      v-model="addressObj.receiverTelephone"
                      v-if="item.selected"
                      @blur="operaValidate"
                    ></el-input>
                    <font v-if="!item.selected">{{item.receiverTelephone}}</font>
                  </div>
                  <div class="shopping-submit-address_info-user">
                    <span>
                      收货地址：
                      <font>{{addressObj.deliveryAddressName}}</font>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="shopping-detail_title shopping-submit_top fl">
            <span></span>
            <font>商品信息</font>
          </div>
          <div class="shopping-sunmit-table fl">
            <el-table
              :data="submitArr"
              :header-cell-style="{background:'#EFF1F5',fontSize:'14px',padding:'7px 0',textAlign:'center'}"
              style="width: 100%"
            >
              <el-table-column label="商品信息">
                <template slot-scope="scope">
                  <div class="shopping-detail_goods-find">
                    <div class="shopping-detail_goods-find-img fl">
                      <img :src="scope.row.productImgUrl">
                    </div>
                    <dl>
                      <dt>
                        {{scope.row.productName}}
                        <font>（{{scope.row.productSpec}}）</font>
                      </dt>
                      <dd>
                        <font
                          v-for="(vals,i) in scope.row.productLabels"
                          :key="vals.id"
                          v-if="i < 3"
                        >{{vals.labelName}}</font>
                      </dd>
                    </dl>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column label="分类" width="150">
                <template slot-scope="scope">
                  <p class="shopping-cen">{{ scope.row.price }}</p>
                </template>
              </el-table-column>-->
              <el-table-column label="单价" width="150">
                <template slot-scope="scope">
                  <p class="shopping-cen">{{ scope.row.price }}</p>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="150">
                <template slot-scope="scope">
                  <p class="shopping-cen">{{ scope.row.quantity }}</p>
                </template>
              </el-table-column>
              <el-table-column label="小计" width="150">
                <template slot-scope="scope">
                  <p class="shopping-cen">{{ scope.row.subtotal }}</p>
                </template>
              </el-table-column>
              <el-table-column label="实付" width="200">
                <template slot-scope="scope">
                  <p class="shopping-cen">{{ scope.row.subtotal }}</p>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="shopping-detail_title shopping-submit_top fl">
            <span></span>
            <font>金额明细</font>
          </div>
          <div class="shopping-submit-price fl">
            <div class="shopping-submit-price_info fr">
              <ul>
                <li>
                  <label>商品件数</label>
                  <span>
                    <font>{{goodsInfo.goodsNum}}</font>件
                  </span>
                </li>
                <li>
                  <label>配件总价</label>
                  <span>
                    <font>{{goodsInfo.goodsPricePJ}}</font>元
                  </span>
                </li>
                <li>
                  <label>产品总价</label>
                  <span>
                    <font>{{goodsInfo.goodsPriceCP}}</font>元
                  </span>
                </li>
                <li>
                  <label>仪器总价</label>
                  <span>
                    <font>{{goodsInfo.goodsPriceYQ}}</font>元
                  </span>
                </li>
                <li>
                  <label>商品总价</label>
                  <span>
                    <font>{{goodsInfo.goodsPriceGoods}}</font>元
                  </span>
                </li>
                <li class="shopping-detail_all-price">
                  <label>应付总额</label>
                  <span>
                    <font>¥ {{goodsInfo.goodsPriceTotal}}</font>元
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="shopping-submit_footer fl">
          <dl>
            <dt>
              {{addressObj.receiverName}}
              <font>{{addressObj.receiverTelephone}}</font>
            </dt>
            <dd>{{addressObj.deliveryAddressName}}</dd>
          </dl>
          <div class="shopping-set_sel-btn fr">
            <el-button type="danger" class="shopping-set_sel-btn_s" @click="operaSubmitOrder">下单结算</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { selectDict, selectReceiverAddress, submitOrder } from "@/api";
import shoppingPublic from "@/assets/js/shoppingPublic";      
        
export default {
  name: "shopping-submit",
  data() {
    return {
      submitArr: [],
      addressList: [],
      goodsInfo: {
        goodsNum: 0,
        goodsPriceCP: 0,
        goodsPricePJ: 0,
        goodsPriceYQ: 0,
        goodsPriceGoods: 0,
        goodsPriceTotal: 0
      },
      addressObj: {
        receiverName: "",
        receiverTelephone: "",
        deliveryAddressName: "",
        id:""
      }
    };
  },
  created() {
    this.operaAddress();
    this.operaGetSessionData();
  },
  methods: {
    //获取从上页面带来的session数据
    operaGetSessionData() {
      this.submitArr = JSON.parse(sessionStorage.getItem("submitArr"));
      this.goodsInfo.goodsNum = this.submitArr.length;
      this.submitArr.forEach((val, index, arr) => {
        this.goodsInfo.goodsPriceGoods += val.subtotal * 1;
        this.goodsInfo.goodsPriceTotal += val.subtotal * 1;
        if (val.categoryCode == "CP") {
          this.goodsInfo.goodsPriceCP += val.subtotal * 1;
        }
        if (val.categoryCode == "PJ") {
          this.goodsInfo.goodsPricePJ += val.subtotal * 1;
        }
        if (val.categoryCode == "YQ") {
          this.goodsInfo.goodsPriceYQ += val.subtotal * 1;
        }
      });
      this.goodsInfo.goodsPriceTotal = shoppingPublic.computePrice(this.goodsInfo.goodsPriceTotal,2);
      this.goodsInfo.goodsPriceGoods = shoppingPublic.computePrice(this.goodsInfo.goodsPriceGoods,2);
      this.goodsInfo.goodsPriceCP = shoppingPublic.computePrice(this.goodsInfo.goodsPriceCP,2);
      this.goodsInfo.goodsPricePJ = shoppingPublic.computePrice(this.goodsInfo.goodsPricePJ,2);
      this.goodsInfo.goodsPriceYQ = shoppingPublic.computePrice(this.goodsInfo.goodsPriceYQ,2);
        this.$store.commit('SEARCH_SHOPPING_GOODS','');
    },
    //获取地址
    operaAddress() {
      selectReceiverAddress({}).then(res => {
        this.addressList = res.obj;
        this.addressList.forEach((val, index, arr) => {
          if (index == 0) {
            val.selected = true;
            this.addressObj = val
          } else {
            val.selected = false;
          }
        });
        console.log(this.addressList);
      });
    },
    //选择地址
    operaSelectAddress(item, index) {
      if (!item.selected) {
        item.selected = !item.selected;
        this.addressList.forEach((val, i, arr) => {
          if (i == index) {
            this.addressObj = val;
          } else {
            val.selected = false;
          }
        });
      }
    },
    operaSubmitOrder() {
      let validate = this.operaValidate();
      if (validate) {
        let submitOrderObj = {};
        submitOrderObj.consignee = this.addressObj.receiverName;
        submitOrderObj.consigneePhone = this.addressObj.receiverTelephone;
        submitOrderObj.deliveryAddress = this.addressObj.id;
        submitOrderObj.createUser = this.$store.state.userInfo.staffId;
        submitOrderObj.orderSystem = this.$store.state.userInfo.brandId;
        submitOrderObj.orderType = '1';
        submitOrderObj.orderNumber = this.submitArr.length;
        submitOrderObj.productInfoENTList = [];
        this.submitArr.forEach((val, index, arr) => {
          let obj = {};
          obj.id = val.productId;
          obj.quantity = val.quantity;
          obj.subtotal = val.subtotal;
          obj.actualPayment = val.subtotal;
          submitOrderObj.productInfoENTList.push(obj);
        });
        submitOrder(submitOrderObj).then(res => {
          if (res.code == 20001) {
          this.$emit("shoppingCars", "shoppingSubmit");
            this.$router.push('/shoppingMall/shoppingMyOrders');
          }
          this.$message({
            type: res.code == 20001 ? "success" : "error",
            message: res.msg
          });
        });
      }
    },
    operaValidate() {
      let pattern = new RegExp("[~'!@#￥$%^&*()-+_=:]");
      let reg = /^1[34578]\d{9}$/;
      if (this.addressObj.receiverName.replace(/\s*/g, "") == "") {
        this.$message({
          type: "error",
          message: "请输入收货人姓名！"
        });
        return false;
      }
      if (pattern.test(this.addressObj.receiverName)) {
        this.$message({
          type: "error",
          message: "姓名中不可以包含特殊字符！"
        });
        return false;
      }
      if (!reg.test(this.addressObj.receiverTelephone)) {
        this.$message({
          type: "error",
          message: "请输入正确的手机号码！"
        });
        return false;
      }
      return true;
    }
  }
};
</script>
<style type="text/css">
.shopping-submit {
  margin-top: 30px;
  background: #ffffff;
}
.shopping-submit_detail {
  padding-left: 60px;
  padding-right: 60px;
  width: 100%;
}
.shopping-submit_top {
  padding-top: 45px;
}
.shopping-detail_title {
  width: 100%;
}
.shopping-detail_title span {
  float: left;
  margin-top: 3px;
  margin-right: 10px;
  width: 6px;
  height: 18px;
  background: #f83c57;
  border-radius: 3px;
}
.shopping-detail_title font {
  float: left;
  font-size: 16px;
  color: #444444;
}
.shopping-submit_footer {
  margin-top: 40px;
  width: 100%;
  height: 127px;
  border-top: 1px solid #d5d9e3;
}
.shopping-submit_footer dl {
  float: left;
  padding-top: 35px;
  padding-left: 60px;
  width: 50%;
}
.shopping-submit_footer dl dt,
.shopping-submit_footer dl dd {
  float: left;
  width: 100%;
  font-size: 14px;
  color: #444444;
}
.shopping-submit_footer dl dt font {
  padding-left: 5px;
}
.shopping-submit_footer dl dd {
  padding-top: 8px;
}
.shopping-set_sel-btn {
  margin-right: 40px;
  margin-left: 17px;
  width: 140px;
}
.shopping-set_sel-btn .shopping-set_sel-btn_s {
  width: 140px;
  height: 48px;
  font-size: 16px;
  color: #ffffff;
  background: #f83c57;
  border-radius: 5px !important;
}
.shopping-submit_footer .shopping-set_sel-btn {
  margin-top: 37px;
}

.shopping-sunmit-table {
  margin-top: 26px;
  width: 100%;
  border: 1px solid #d5d9e3;
}

.shopping-submit-address {
  margin-top: 16px;
  width: 100%;
}

.shopping-submit-address_li {
  margin-top: 10px;
  display: flex;
  width: 100%;
  height: 90px;
  background: #f6f7f9;
}
.shopping-submit-address_select {
  display: flex;
  margin-left: 46px;
  margin-right: 21px;
  width: 18px;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
}
.shopping-submit-address_select span {
  float: left;
  width: 18px;
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #ffffff;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #c0c5cf;
}
.shopping-submit-address_select.on span {
  border: none;
  background: #f83b56;
}
.shopping-submit-address_info {
  padding-top: 15px;
  flex: 1;
}
.shopping-submit-address_info-user {
  width: 100%;
  line-height: 30px;
}
.shopping-submit-address_info-user span {
  margin-left: 25px;
  font-size: 14px;
  color: #666666;
}
.shopping-submit-address_info-user font {
  font-size: 14px;
  color: #222222;
}
.shopping-submit-address_info-user .el-input {
  width: 100px;
  height: 30px;
}
.shopping-submit-address_info-user .el-input__inner {
  padding: 0 0 0 5px;
  width: 100%;
  height: 30px;
  line-height: 30px;
}
.shopping-submit-address_info-user_phone.el-input {
  width: 150px;
}
.shopping-submit-price {
  width: 100%;
}
.shopping-submit-price_info {
  width: 250px;
}
.shopping-submit-price_info ul {
  float: left;
  width: 100%;
}
.shopping-submit-price_info ul li {
  float: left;
  margin-top: 5px;
  width: 100%;
  font-size: 14px;
  color: #444444;
}
.shopping-submit-price_info ul li label {
  float: left;
  width: 60px;
}
.shopping-submit-price_info ul li span {
  float: right;
  text-align: right;
}
.shopping-submit-price_info ul li font {
  margin-right: 5px;
}
.shopping-submit-price_info ul .shopping-detail_all-price {
  margin-top: 23px;
  line-height: 24px;
}
.shopping-detail_all-price font {
  font-size: 24px;
  color: #f83c57;
}
</style>


// WEBPACK FOOTER //
// src/components/shoppingMall/shoppingSubmit.vue